import {ValueObject} from '@s-ui/domain'

export class LeadHitUserValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {string} data.adId
   * @param {string} data.contractId
   * @param {Number} data.leadType
   * */

  /**
   * Validation method
   */
  static validate({adId, contractId, leadType, config, errorFactory}) {
    const {LEAD_HIT_TYPES} = config.get('user')
    const hasValidType = Object.values(LEAD_HIT_TYPES).some(validType => validType === leadType)

    if (!hasValidType) throw errorFactory('Lead type is not valid')
    if (!adId && !contractId) throw errorFactory('Lead hit needs an ad ID or contract ID')
  }
}
